<template>
  <v-footer dark height="auto">
    <v-card class="flex" flat tile>
      <v-card-actions class="grey darken-3">
        &copy;2018 — <strong>清大學程小幫手</strong>
        <v-spacer></v-spacer>
        <a class="white--text" target="_blank" href="https://privacypolicies.com/privacy/view/9a9d0fd38d2971f906f01c3a1c8486cf">隱私權政策</a>
      </v-card-actions>
    </v-card>
  </v-footer>
</template>

<script>
export default {
  name: 'app-footer',
}
</script>